import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit, faUserSlash, faUserCheck, faUser } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Button, Table, Form, Modal, Alert, Spinner } from '@themesberg/react-bootstrap';
import { jwtDecode } from 'jwt-decode';
import moment from 'moment';
import "../../../scss/belts.css";


export default () => {
    const [praticantes, setPraticantes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [currentPraticante, setCurrentPraticante] = useState({});
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [fotoPreview, setFotoPreview] = useState(null);
    const [isProcessingFoto, setIsProcessingFoto] = useState(false);
    const [search, setSearch] = useState("");
    const [turmas, setTurmas] = useState([]);
    const [turmasPraticante, setTurmasPraticante] = useState([]);
    const [showInactive, setShowInactive] = useState(false);
    const [orderBy, setOrderBy] = useState("graduacao");
    const [orderDir, setOrderDir] = useState("asc");
    const [utilizadores, setUtilizadores] = useState([]);

    const GRADUACOES = [
        { value: 0, nome: "9º Kyu", cor: "Branco", className: "belt-white" },
        { value: 1, nome: "8º Kyu", cor: "Amarelo", className: "belt-yellow" },
        { value: 2, nome: "7º Kyu", cor: "Laranja", className: "belt-orange" },
        { value: 3, nome: "6º Kyu", cor: "Verde", className: "belt-green" },
        { value: 4, nome: "5º Kyu", cor: "Azul", className: "belt-blue" },
        { value: 5, nome: "4º Kyu", cor: "Vermelho", className: "belt-red" },
        { value: 6, nome: "3º Kyu", cor: "Castanho", className: "belt-brown" },
        { value: 7, nome: "2º Kyu", cor: "Castanho", className: "belt-brown" },
        { value: 8, nome: "1º Kyu", cor: "Castanho", className: "belt-brown" },

        // 1º a 10º Dan
        ...Array.from({ length: 10 }, (_, i) => ({
            value: 9 + i,
            nome: `${i + 1}º Dan`,
            cor: "Preto",
            className: "belt-black"
        }))
    ];


    const getGraduacaoInfo = (value) =>
        GRADUACOES.find(g => g.value === value);


    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const fetchPraticantes = async () => {
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        try {
            const response = await fetch(`${API_BASE_URL}/Praticantes`, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                setPraticantes(data);
            } else {
                setError('Falha ao carregar os praticantes.');
            }
        } catch (err) {
            setError('Erro de rede ao carregar os praticantes.');
        }
    };

    const fetchUtilizadores = async () => {
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        try {
            const response = await fetch(`${API_BASE_URL}/Utilizadores`, { // Confirma se o endpoint é /Users ou /Utilizadores
                headers: { "Authorization": `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                setUtilizadores(data); // Garante que este state existe: const [utilizadores, setUtilizadores] = useState([]);
            }
        } catch (err) {
            console.error("Erro ao procurar utilizadores:", err);
        }
    };

    const getNomeUtilizador = (idRecebido) => {
        if (!idRecebido || !utilizadores.length) return "Não associado";

        // Procuramos o user cujo 'id' coincida com o 'utilizadorId' do praticante
        const user = utilizadores.find(u => Number(u.id) === Number(idRecebido));

        return user ? user.nome : `Não encontrado (${idRecebido})`;
    };

    // No useEffect inicial, adiciona o fetchUtilizadores() ao Promise.all

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAll = async () => {
            try {
                setLoading(true);
                await Promise.all([
                    fetchPraticantes(),
                    fetchTurmas(),
                    fetchTurmasPraticante(),
                    fetchUtilizadores()
                ]);
            } catch (err) {
                console.error(err);
                setError("Erro ao carregar dados iniciais.");
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, []);



    const handleShowModal = (praticante, editar = false) => {
        const formattedPraticante = {
            ...praticante,
            dataNascimento: praticante.dataNascimento
                ? moment(praticante.dataNascimento).format('YYYY-MM-DD')
                : ''
        };

        setCurrentPraticante(formattedPraticante);
        setFotoPreview(praticante.fotografia ? `data:image/png;base64,${praticante.fotografia}` : null);
        setIsEditing(editar);
        setShowModal(true);
        setError('');
        setSuccess('');
    };


    const handleCloseModal = () => setShowModal(false);

    const fetchTurmas = async () => {
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        const res = await fetch(`${API_BASE_URL}/Turmas`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        if (!res.ok) {
            throw new Error("Erro ao carregar turmas");
        }

        const data = await res.json();
        setTurmas(data);
    };

    const fetchTurmasPraticante = async () => {
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        const res = await fetch(`${API_BASE_URL}/TurmasPraticantes`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        if (!res.ok) {
            throw new Error("Erro ao carregar turmas do praticante");
        }

        const data = await res.json();
        setTurmasPraticante(data);
    };

    const getTurmasDoPraticante = (praticanteId) => {
        if (!turmas.length || !turmasPraticante.length) {
            return [];
        }

        const pid = Number(praticanteId);

        const turmaIds = turmasPraticante
            .filter(tp => Number(tp.praticanteId) === pid)
            .map(tp => Number(tp.turmaId));

        return turmas.filter(t => turmaIds.includes(Number(t.id)));
    };




    const getFotografiaBase64 = file => new Promise((resolve, reject) => {
        // 1. Se não há nada, resolve null
        if (!file) return resolve(null);

        // 2. Se já for uma string (Base64 que veio da base de dados), não processa, devolve a string
        if (typeof file === 'string') {
            return resolve(file);
        }

        // 3. Se for um objeto File (nova foto selecionada), processa
        setIsProcessingFoto(true);
        const reader = new FileReader();
        reader.onload = () => {
            setIsProcessingFoto(false);
            // Limpa o prefixo caso o reader o adicione
            const base64String = reader.result.includes(',')
                ? reader.result.split(',')[1]
                : reader.result;
            resolve(base64String);
        };
        reader.onerror = err => {
            setIsProcessingFoto(false);
            reject(err);
        };
        reader.readAsDataURL(file);
    });

    const handleSavePraticante = async (e) => {
        e.preventDefault();
        if (isProcessingFoto) return;

        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        const url = `${API_BASE_URL}/Praticantes/${currentPraticante.id}`;

        try {
            // Agora a função lida corretamente com File ou String
            const fotografiaBase64 = await getFotografiaBase64(currentPraticante.fotografia);

            const dataToSend = {
                ...currentPraticante,
                // Converte valores para o formato esperado pelo C# (int/DateTime)
                nif: currentPraticante.nif ? parseInt(currentPraticante.nif) : null,
                telefone: currentPraticante.telefone ? parseInt(currentPraticante.telefone) : 0,
                n_CPK: currentPraticante.n_CPK ? parseInt(currentPraticante.n_CPK) : null,
                n_Federacao: currentPraticante.n_Federacao ? parseInt(currentPraticante.n_Federacao) : null,
                dataNascimento: currentPraticante.dataNascimento
                    ? new Date(currentPraticante.dataNascimento).toISOString()
                    : null,
                fotografia: fotografiaBase64 // Envia a string limpa
            };

            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(dataToSend)
            });

            if (response.ok) {
                setSuccess('Praticante atualizado com sucesso!');
                handleCloseModal();
                fetchPraticantes();
            } else {
                const errorText = await response.text();
                setError(`Erro do servidor: ${errorText}`);
            }
        } catch (err) {
            console.error("Erro no salvamento:", err);
            setError('Erro ao processar os dados ou a fotografia.');
        }
    };

    const calcularIdade = (dataNascimento) => {
        if (!dataNascimento) return "—";

        const nascimento = new Date(dataNascimento);
        if (isNaN(nascimento)) return "—";

        const hoje = new Date();
        let idade = hoje.getFullYear() - nascimento.getFullYear();

        const m = hoje.getMonth() - nascimento.getMonth();
        if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
            idade--;
        }

        return idade;
    };

    const idadeParaOrdenar = (dataNascimento) => {
        const idade = calcularIdade(dataNascimento);
        return typeof idade === "number" ? idade : -1;
    };


    const handleToggleActive = async (praticante) => {
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        const updatedPraticante = { ...praticante, isAtivo: praticante.isAtivo === 1 ? 0 : 1 };

        try {
            const response = await fetch(`${API_BASE_URL}/Praticantes/${praticante.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(updatedPraticante)
            });
            if (response.ok) {
                setSuccess('Estado do praticante atualizado com sucesso!');
                fetchPraticantes();
            } else {
                setError('Falha ao atualizar o estado do praticante.');
            }
        } catch (err) {
            setError('Erro de rede ao atualizar o estado do praticante.');
        }
    };

    const handleFotoChange = e => {
        const file = e.target.files[0];
        if (!file) return;
        setCurrentPraticante({ ...currentPraticante, fotografia: file });
        setFotoPreview(URL.createObjectURL(file));
    };

    const renderFoto = (foto) => {
        if (!foto) return <span>N/A</span>;
        return <img src={`data:image/png;base64,${foto}`} alt="Foto" style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '50%' }} />;
    };

    const praticantesProcessados = [...praticantes]
        .filter(p =>
            p.nome?.toLowerCase().includes(search.toLowerCase()) &&
            (showInactive || p.isAtivo === 1) // filtra ativos por default
        )
        .sort((a, b) => {
            if (orderBy === "graduacao") {
                const gA = a.graduacao || 0;
                const gB = b.graduacao || 0;
                return orderDir === "asc" ? gA - gB : gB - gA;
            }

            if (orderBy === "idade") {
                const idadeA = idadeParaOrdenar(a.dataNascimento);
                const idadeB = idadeParaOrdenar(b.dataNascimento);
                return orderDir === "asc" ? idadeA - idadeB : idadeB - idadeA;
            }

            return 0;
        });

    const InfoItem = ({ label, value }) => (
        <div className="mb-2">
            <small className="text-muted">{label}</small>
            <div className="fw-semibold">{value || "—"}</div>
        </div>
    );


    useEffect(() => {
        console.log("Turmas:", turmas);
        console.log("TurmasPraticante:", turmasPraticante);
    }, [turmas, turmasPraticante]);


    return (
        <>
            <div className="d-flex justify-content-between flex-wrap gap-3 align-items-start py-4">
                <div>
                    <h1 className="h4 mb-1">Gestão de Praticantes</h1>
                    <p className="mb-0 text-muted">Veja e edite todos os praticantes do clube.</p>
                </div>
            </div>

            {success && <Alert variant="success" onClose={() => setSuccess('')} dismissible>{success}</Alert>}
            {error && <Alert variant="danger" onClose={() => setError('')} dismissible>{error}</Alert>}

            {/* Filtros */}
            <Row className="mb-3 g-2">
                <Col xs={12} sm={4}>
                    <Form.Control placeholder="Filtrar por nome..." value={search} onChange={e => setSearch(e.target.value)} />
                </Col>
                <Col xs={6} sm={3}>
                    <Form.Select value={orderBy} onChange={e => setOrderBy(e.target.value)}>
                        <option value="graduacao">Ordenar por Graduação</option>
                        <option value="idade">Ordenar por Idade</option>
                    </Form.Select>
                </Col>
                <Col xs={6} sm={2}>
                    <Form.Select value={orderDir} onChange={e => setOrderDir(e.target.value)}>
                        <option value="asc">Ascendente</option>
                        <option value="desc">Descendente</option>
                    </Form.Select>
                </Col>
                <Col xs={12} sm={3} className="d-flex align-items-center">
                    <Form.Check type="checkbox" label="Mostrar inativos" checked={showInactive} onChange={e => setShowInactive(e.target.checked)} />
                </Col>
            </Row>

            {/* Tabela — desktop */}
            <div className="d-none d-md-block">
                <Card border="light" className="shadow-sm">
                    <Card.Body className="p-0">
                        <Table hover responsive className="align-items-center mb-0">
                            <thead className="thead-light">
                            <tr>
                                <th className="text-center">Foto</th>
                                <th>Nome</th>
                                <th>Estado</th>
                                <th className="text-center">Idade</th>
                                <th>Graduação</th>
                                <th>Turmas</th>
                                <th className="text-center">Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            {praticantesProcessados.map(p => (
                                <tr key={p.id}>
                                    <td className="text-center">
                                        {p.fotografia
                                            ? <img src={`data:image/png;base64,${p.fotografia}`} alt="Foto" style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }} />
                                            : <span className="text-muted">—</span>}
                                    </td>
                                    <td className="fw-bold">{p.nome}</td>
                                    <td>
                                        <span className={`badge bg-${p.isAtivo === 1 ? "success" : "danger"}`}>
                                            {p.isAtivo === 1 ? "Ativo" : "Inativo"}
                                        </span>
                                    </td>
                                    <td className="text-center">{calcularIdade(p.dataNascimento)}</td>
                                    <td>
                                        {(() => { const g = getGraduacaoInfo(p.graduacao); return g ? <span className={`belt-badge ${g.className}`}>{g.nome}</span> : "—"; })()}
                                    </td>
                                    <td style={{ maxWidth: 200 }}>
                                        {getTurmasDoPraticante(p.id).length > 0
                                            ? getTurmasDoPraticante(p.id).map(t => t.turma).join(", ")
                                            : <span className="text-muted">Sem turma</span>}
                                    </td>
                                    <td className="text-center">
                                        <div className="d-flex justify-content-center gap-1">
                                            <Button variant="outline-info" size="sm" onClick={() => handleShowModal(p, false)}><FontAwesomeIcon icon={faEye} /></Button>
                                            <Button variant="outline-primary" size="sm" onClick={() => handleShowModal(p, true)}><FontAwesomeIcon icon={faEdit} /></Button>
                                            <Button variant={p.isAtivo === 1 ? "outline-danger" : "outline-success"} size="sm" onClick={() => handleToggleActive(p)}>
                                                <FontAwesomeIcon icon={p.isAtivo === 1 ? faUserSlash : faUserCheck} />
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>

            {/* Cards — mobile */}
            <div className="d-md-none">
                {praticantesProcessados.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "48px 20px", background: "white", borderRadius: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                        <p className="text-muted mb-0 fw-bold">Nenhum praticante encontrado.</p>
                    </div>
                ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        {praticantesProcessados.map(p => {
                            const g = getGraduacaoInfo(p.graduacao);
                            const isAtivo = p.isAtivo === 1;
                            return (
                                <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 14, background: "white", borderRadius: 14, padding: "14px 16px", boxShadow: "0 2px 8px rgba(0,0,0,0.07)", border: "1px solid #f0f0f5" }}>
                                    <div style={{ width: 52, height: 52, minWidth: 52, borderRadius: "50%", overflow: "hidden", border: "2px solid #e9ecef", backgroundColor: "#f0f0f5", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                        {p.fotografia
                                            ? <img src={`data:image/png;base64,${p.fotografia}`} alt={p.nome} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                            : <span style={{ fontSize: 20, fontWeight: 800, color: "#1e1d45" }}>{p.nome?.charAt(0).toUpperCase()}</span>}
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontWeight: 700, fontSize: 15, color: "#1e1d45", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{p.nome}</div>
                                        <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4, flexWrap: "wrap" }}>
                                            <span className={`badge bg-${isAtivo ? "success" : "danger"}`} style={{ fontSize: 10 }}>{isAtivo ? "Ativo" : "Inativo"}</span>
                                            {g && <span className={`belt-badge ${g.className}`} style={{ fontSize: 10 }}>{g.nome}</span>}
                                            <span style={{ fontSize: 12, color: "#adb5bd" }}>{calcularIdade(p.dataNascimento)} anos</span>
                                        </div>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column", gap: 6, flexShrink: 0 }}>
                                        <button onClick={() => handleShowModal(p, false)} style={{ width: 36, height: 36, borderRadius: 8, border: "1px solid #dee2e6", background: "white", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#0d6efd" }}>
                                            <FontAwesomeIcon icon={faEye} size="sm" />
                                        </button>
                                        <button onClick={() => handleShowModal(p, true)} style={{ width: 36, height: 36, borderRadius: 8, border: "1px solid #dee2e6", background: "white", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#6c757d" }}>
                                            <FontAwesomeIcon icon={faEdit} size="sm" />
                                        </button>
                                        <button onClick={() => handleToggleActive(p)} style={{ width: 36, height: 36, borderRadius: 8, border: "1px solid #dee2e6", background: "white", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: isAtivo ? "#dc3545" : "#198754" }}>
                                            <FontAwesomeIcon icon={isAtivo ? faUserSlash : faUserCheck} size="sm" />
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>

            {/* Modal */}
            <Modal as={Modal.Dialog} centered show={showModal} onHide={handleCloseModal} size="lg" scrollable>
                <Modal.Header closeButton style={{ borderBottom: "none", paddingBottom: 0 }}>
                    <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>
                        {isEditing ? "Editar Praticante" : "Perfil do Praticante"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ paddingTop: 8 }}>
                    {!isEditing ? (
                        <>
                            {/* Hero */}
                            <div style={{ background: "linear-gradient(135deg, #1e1d45 0%, #2d2c6b 100%)", borderRadius: 12, padding: "24px 20px 20px", marginBottom: 24 }}>
                                <Row className="align-items-center g-3">
                                    <Col xs={12} sm="auto" className="text-center text-sm-start">
                                        <div style={{ width: 88, height: 88, borderRadius: "50%", overflow: "hidden", border: "3px solid rgba(255,255,255,0.3)", backgroundColor: "rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto" }}>
                                            {fotoPreview
                                                ? <img src={fotoPreview} alt="Perfil" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                : <span style={{ fontSize: 36, fontWeight: 900, color: "white" }}>{currentPraticante.nome?.charAt(0).toUpperCase()}</span>}
                                        </div>
                                    </Col>
                                    <Col xs={12} sm>
                                        <h3 style={{ color: "white", fontWeight: 800, fontSize: 20, marginBottom: 6 }}>{currentPraticante.nome}</h3>
                                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 8 }}>
                                            <span className={`badge bg-${currentPraticante.isAtivo === 1 ? "success" : "danger"}`}>
                                                {currentPraticante.isAtivo === 1 ? "Ativo" : "Inativo"}
                                            </span>
                                            {(() => { const g = getGraduacaoInfo(currentPraticante.graduacao); return g ? <span className={`belt-badge ${g.className}`} style={{ fontSize: 11 }}>{g.nome}</span> : null; })()}
                                            <span style={{ color: "rgba(255,255,255,0.6)", fontSize: 12 }}>ID #{currentPraticante.id}</span>
                                        </div>
                                        <div style={{ background: "rgba(255,255,255,0.1)", borderRadius: 8, padding: "8px 12px" }}>
                                            <small style={{ color: "rgba(255,255,255,0.7)", fontSize: 11 }}>Turmas:</small>
                                            <div style={{ color: "white", fontWeight: 600, fontSize: 13 }}>
                                                {getTurmasDoPraticante(currentPraticante.id).map(t => t.turma).join(", ") || "Sem turmas atribuídas"}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {[
                                {
                                    titulo: "Dados Pessoais e Identificação",
                                    campos: [
                                        { label: "Idade", value: `${calcularIdade(currentPraticante.dataNascimento)} anos` },
                                        { label: "Data Nascimento", value: moment(currentPraticante.dataNascimento).format("DD/MM/YYYY") },
                                        { label: "Sexo", value: currentPraticante.sexo === 'M' ? "Masculino" : currentPraticante.sexo === 'F' ? "Feminino" : "—" },
                                        { label: "Telefone", value: currentPraticante.telefone },
                                        { label: "NIF", value: currentPraticante.nif },
                                        { label: "Cartão Cidadão", value: currentPraticante.cc },
                                        { label: "Nacionalidade", value: currentPraticante.nacionalidade },
                                        { label: "Naturalidade", value: currentPraticante.naturalidade },
                                    ]
                                },
                                {
                                    titulo: "Contacto e Morada",
                                    campos: [
                                        { label: "Email", value: currentPraticante.email, full: true },
                                        { label: "Morada", value: currentPraticante.morada, full: true },
                                        { label: "Localidade", value: currentPraticante.localidade },
                                        { label: "Código Postal", value: currentPraticante.cp },
                                    ]
                                },
                                {
                                    titulo: "Dados Federativos e Competição",
                                    campos: [
                                        { label: "Nº CPK", value: currentPraticante.n_CPK },
                                        { label: "Nº Federação", value: currentPraticante.n_Federacao },
                                        { label: "Kata", value: currentPraticante.kata === 1 ? "Sim" : "Não" },
                                        { label: "Kumite", value: currentPraticante.kumite === 1 ? "Sim" : "Não" },
                                        { label: "Utilizador", value: getNomeUtilizador(currentPraticante.utilizadorId), full: true },
                                    ]
                                },
                            ].map(secao => (
                                <div key={secao.titulo} className="mb-4">
                                    <h6 className="mb-3 text-primary fw-bold">{secao.titulo}</h6>
                                    <Row className="g-3">
                                        {secao.campos.map(campo => (
                                            <Col xs={campo.full ? 12 : 6} md={campo.full ? 12 : 3} key={campo.label}>
                                                <InfoItem label={campo.label} value={campo.value} />
                                            </Col>
                                        ))}
                                    </Row>
                                    <hr />
                                </div>
                            ))}

                            {currentPraticante.notas && (
                                <div className="bg-light p-3 rounded border mb-3">
                                    <h6 className="small fw-bold text-muted mb-2">Notas Administrativas</h6>
                                    <p className="mb-0 small" style={{ whiteSpace: "pre-wrap" }}>{currentPraticante.notas}</p>
                                </div>
                            )}

                            <div className="d-flex gap-2">
                                <Button variant="outline-secondary" className="flex-grow-1" onClick={handleCloseModal}>Fechar</Button>
                                <Button variant="primary" className="flex-grow-1" onClick={() => setIsEditing(true)}>
                                    <FontAwesomeIcon icon={faEdit} className="me-2" /> Editar Praticante
                                </Button>
                            </div>
                        </>
                    ) : (
                        <>
                            {/* 🔹 MODO EDITAR */}
                            <Form onSubmit={handleSavePraticante}>
                                <h6 className="mb-3 text-primary border-bottom pb-2">Dados Obrigatórios</h6>
                                <Row>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nome Completo</Form.Label>
                                            <Form.Control
                                                required
                                                placeholder="Nome do Praticante"
                                                value={currentPraticante.nome || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, nome: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data Nascimento</Form.Label>
                                            <Form.Control
                                                type="date"
                                                required
                                                value={currentPraticante.dataNascimento || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, dataNascimento: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Sexo</Form.Label>
                                            <Form.Select
                                                required
                                                value={currentPraticante.sexo || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, sexo: e.target.value})}>
                                                <option value="">Selecione...</option>
                                                <option value="M">Masculino</option>
                                                <option value="F">Feminino</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Graduação</Form.Label>
                                            <Form.Select
                                                value={currentPraticante.graduacao ?? 0}
                                                onChange={e => setCurrentPraticante({...currentPraticante, graduacao: parseInt(e.target.value)})}
                                            >
                                                {GRADUACOES.map(g => (
                                                    <option key={g.value} value={g.value}>
                                                        {g.nome} • {g.cor}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <hr />
                                <h6 className="mb-3 text-primary border-bottom pb-2">Identificação e Origem</h6>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>NIF</Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Contribuinte"
                                                value={currentPraticante.nif || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, nif: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Cartão Cidadão</Form.Label>
                                            <Form.Control
                                                placeholder="Nº Documento"
                                                value={currentPraticante.cc || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, cc: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nacionalidade</Form.Label>
                                            <Form.Control
                                                placeholder="Ex: Portuguesa"
                                                value={currentPraticante.nacionalidade || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, nacionalidade: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Naturalidade</Form.Label>
                                            <Form.Control
                                                placeholder="Natural de..."
                                                value={currentPraticante.naturalidade || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, naturalidade: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <hr />
                                <h6 className="mb-3 text-primary border-bottom pb-2">Dados Federativos e Contacto</h6>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nº CPK</Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={currentPraticante.n_CPK || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, n_CPK: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nº Federação</Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={currentPraticante.n_Federacao || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, n_Federacao: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Telefone</Form.Label>
                                            <Form.Control
                                                type="tel"
                                                value={currentPraticante.telefone || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, telefone: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                value={currentPraticante.email || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, email: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Morada</Form.Label>
                                            <Form.Control
                                                value={currentPraticante.morada || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, morada: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Localidade</Form.Label>
                                            <Form.Control
                                                value={currentPraticante.localidade || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, localidade: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Cód. Postal</Form.Label>
                                            <Form.Control
                                                value={currentPraticante.cp || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, cp: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <hr />
                                <h6 className="mb-3 text-primary border-bottom pb-2">Configurações de Competição e Notas</h6>
                                <Row>
                                    <Col md={6} className="d-flex align-items-center">
                                        <Form.Check
                                            type="switch"
                                            id="kata-switch"
                                            label="Competição Kata"
                                            className="me-4"
                                            checked={currentPraticante.kata === 1}
                                            onChange={e => setCurrentPraticante({...currentPraticante, kata: e.target.checked ? 1 : 0})}
                                        />
                                        <Form.Check
                                            type="switch"
                                            id="kumite-switch"
                                            label="Competição Kumite"
                                            checked={currentPraticante.kumite === 1}
                                            onChange={e => setCurrentPraticante({...currentPraticante, kumite: e.target.checked ? 1 : 0})}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Notas Internas</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                placeholder="Observações administrativas..."
                                                value={currentPraticante.notas || ''}
                                                onChange={e => setCurrentPraticante({...currentPraticante, notas: e.target.value})}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <hr />
                                <Form.Group className="mb-4">
                                    <Form.Label>Fotografia de Perfil</Form.Label>
                                    <div className="d-flex align-items-center bg-light p-3 rounded border border-dashed">
                                        {fotoPreview && (
                                            <img src={fotoPreview} alt="Preview" className="me-3 rounded border shadow-sm"
                                                 style={{width: '60px', height: '60px', objectFit: 'cover'}}/>
                                        )}
                                        <Form.Control
                                            type="file"
                                            accept="image/*"
                                            onChange={handleFotoChange}
                                            className="bg-white"
                                        />
                                    </div>
                                </Form.Group>

                                <div className="d-flex gap-2 border-top pt-3">
                                    <Button variant="outline-secondary" className="flex-grow-1" onClick={handleCloseModal}>Cancelar</Button>
                                    <Button variant="primary" type="submit" className="flex-grow-1" disabled={isProcessingFoto}>
                                        {isProcessingFoto ? (<><Spinner animation="border" size="sm" className="me-2"/> A guardar...</>) : "Guardar Alterações"}
                                    </Button>
                                </div>
                            </Form>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};
